export default {
  MuiSelect: {
    defaultProps: {
      MenuProps: {
        PaperProps: {
          style: {
            maxHeight: '200px'
          }
        }
      }
    },
    styleOverrides: {
      select: {
        minWidth: '6rem !important',
        '&.MuiTablePagination-select': {
          minWidth: '1.5rem !important'
        }
      }
    }
  }
}
